export const UnitOfMeasure = Object.freeze({
  millimeters: { id: 'Millimeters', label: 'mm' },
  inches: { id: 'Inches', label: 'in' },
});

export default class UnitOfMeasureType {
  static async all() {
    return Object.keys(UnitOfMeasure).map((key) => ({
      id: UnitOfMeasure[key].id,
      label: UnitOfMeasure[key].label,
    }));
  }
}
